import React from 'react';
import './QuienesSomos.css';
import { Link } from 'react-router-dom';
import PageBanner from '../../layout/PageBanner';

const QuienesSomos = (props) => (
  <div >
    <PageBanner title="Quiénes Somos" img="banner-quienes-somos.jpg">
      <Link to="/">Home</Link>
      <Link to="/quienes-somos">Quiénes Somos</Link>
    </PageBanner>

    <section className="about-ds">
      <div className="container">
        <div className="row">
          <div className="col-md-12 col-sm-6 about-ds-content">
            <div className="section-header03">
              <h2><span>Programa de derecho</span> y bienes públicos</h2>
            </div>
            <p className="fade-in" dangerouslySetInnerHTML={{ __html: props.text }}></p>
          </div>
        </div>
      </div>
    </section>

    {props.staffResponsables.length > 0 &&
      <div className="teachers06">
        <div className="container">
          <div className="row">
            <div className="col-sm-12 section-header03">
              <h2 className="flacso-verde">Responsables</h2>
            </div>
            <div className="col-sm-12 teachers-block owl-carousel driving-teacher">
              {props.staffResponsables.map((resp, index) =>

                <div className="teacher-single col-sm-3 teacher-fix fade-in" key={index}>
                  <Link to={{ pathname: `/quienes-somos/${resp.id}`, state: { resp } }}>
                    <img src={resp.imagen} alt="" className="img-responsive" />
                    <div className="teacher-info">
                      <h4>{resp.nombre}</h4>
                      <span>{resp.cargo}</span>
                    </div>
                  </Link>
                </div>

              )}
            </div>
          </div>
        </div>
      </div>
    }

    {props.staffCatedraOMC.length > 0 &&
      <div className="teachers06">
        <div className="container">
          <div className="row">
            <div className="col-sm-12 section-header03">
              <h2 className="flacso-verde">Investigadores de Cátedra OMC</h2>
            </div>
            <div className="col-sm-12 teachers-block owl-carousel driving-teacher">
              {props.staffCatedraOMC.map((resp, index) =>

                <div className="teacher-single col-sm-3 teacher-fix fade-in" key={index}>
                  <Link to={{ pathname: `/quienes-somos/${resp.id}`, state: { resp } }}>
                    <img src={resp.imagen} alt="" className="img-responsive" />
                    <div className="teacher-info">
                      <h4>{resp.nombre}</h4>
                      <span>{resp.cargo}</span>
                    </div>
                  </Link>
                </div>

              )}
            </div>
          </div>
        </div>
      </div>
    }

    {props.staffPropIntel.length > 0 &&
      <div className="teachers06">
        <div className="container">
          <div className="row">
            <div className="col-sm-12 section-header03">
              <h2 className="flacso-verde">Investigadores de Propiedad Intelectual</h2>
            </div>
            <div className="col-sm-12 teachers-block owl-carousel driving-teacher">
              {props.staffPropIntel.map((resp, index) =>

                <div className="teacher-single col-sm-3 teacher-fix fade-in" key={index}>
                  <Link to={{ pathname: `/quienes-somos/${resp.id}`, state: { resp } }}>
                    <img src={resp.imagen} alt="" className="img-responsive" />
                    <div className="teacher-info">
                      <h4>{resp.nombre}</h4>
                      <span>{resp.cargo}</span>
                    </div>
                  </Link>
                </div>

              )}
            </div>
          </div>
        </div>
      </div>
    }

  </div>
);

export default QuienesSomos;
